import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=ef494c3a&scoped=true"
import script from "./terms_of_service.js?vue&type=script&lang=js&external"
export * from "./terms_of_service.js?vue&type=script&lang=js&external"
import style0 from "./terms_of_service.scss?vue&type=style&index=0&id=ef494c3a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef494c3a",
  null
  
)

export default component.exports